import { AlertColorProp } from '../properties';
import { AlertColorType } from '../types';

export function getAlertColor(color?: AlertColorType) {
  if (!color) return '';

  return AlertColorProp[color];
}
